// extracted by mini-css-extract-plugin
module.exports = {"couponContainer":"Coupon_couponContainer__k3ljb","disabled":"Coupon_disabled__L22_I","shipping":"Coupon_shipping__vYKWN","expiryTime":"Coupon_expiryTime__57OCr","couponInfoIcon":"Coupon_couponInfoIcon__Mw_5P","info-icon":"Coupon_info-icon__REM3E"};
module.exports.__checksum = "3472c747bf4f"
